export class MarangoChangePasswordResponseDTO {}
